<template>
  <a class="card border border-2 border-gray-300 border-hover cursor-pointer" :class="cardClasses">
    <div class="card-header flex-nowrap border-0 pt-9">
      <div class="card-title m-0">
        <div class="symbol symbol-45px w-25px me-5" v-if="eem_status=='Brouillon'">
          <i class="fs-3 bi bi-file-earmark-post" style="color: #ffbc01"></i>
        </div>
        <div class="symbol symbol-45px w-25px me-5" v-if="eem_status=='Refusé'">
          <i class="fs-3 bi-exclamation-octagon-fill text-danger" ></i>
        </div>
        <div class="symbol symbol-45px w-25px me-5" v-if="eem_status=='En attente de validation'">
          <i class="fs-3 bi-hourglass-split text-warning" ></i>
        </div>
        <div class="symbol symbol-45px w-25px me-5" v-if="eem_status=='Validé'">
          <i class="fs-3 bi-check-square-fill text-success" ></i>
        </div>  

        <span class="fs-4 fw-bold text-hover-primary text-gray-600 m-0">
          {{ eem_libelle }}
        </span>
      </div>

    </div>

    <div class="card-body d-flex flex-column px-9 pt-0 pb-8">
      <div v-if="eem_repas_mois" class="fs-4 mb-3 text-gray-700">
        Quantité de repas client : <span class="fs-4 fw-bolder mb-3 text-gray-700">{{ eem_repas_mois }}</span>
      </div>
      <div v-if="eem_kms_mois" class="fs-4 mb-3 text-gray-700">
        Compteur kilométrique : <span class="fs-4 fw-bolder mb-3 text-gray-700">{{ formatMilliers(eem_kms_mois) }}</span>
      </div>
      <div v-if="eem_usage_voiture_pro" class="fs-4 mb-3 text-gray-700">
        Usage voiture pro (%) : <span class="fs-4 fw-bolder mb-3 text-gray-700">{{ eem_usage_voiture_pro }}</span> 
      </div>
      <div v-if="eem_usage_voiture_perso" class="fs-4 mb-3 text-gray-700">
        Usage voiture perso (%) : <span class="fs-4 fw-bolder mb-3 text-gray-700">{{ eem_usage_voiture_perso }}</span>
      </div>
      <div v-if="eem_x_conges" class="fs-4 mb-3 text-gray-700">
        Congés saisis pour le mois : <span class="fs-4 fw-bolder mb-3 text-gray-700">{{ eem_x_conges === '1' ? 'Oui' : 'Non' }}</span>
      </div>
      <div v-if="eem_tot_heures_hno" class="fs-4 mb-3 text-gray-700">
        Total heures HNO : <span class="fs-4 fw-bolder mb-3 text-gray-700">{{ eem_tot_heures_hno }}</span>
      </div>

      <div class="d-flex align-items-center flex-wrap mb-5 mt-auto fs-6">
        <span :class="`svg-icon-${color}`" class="svg-icon svg-icon-3 me-1">
          <inline-svg :src="`media/icons/duotune/Navigation/${arrow}.svg`" />
        </span>

        <div :class="`text-${color}`" class="fw-bolder me-2">
          {{ eem_status }}
        </div>

        <div class="fw-bold text-gray-400">
          {{ footerText }}
        </div>
      </div>

      <div class="d-flex align-items-center fw-bold">
        <span class="badge bg-light text-gray-700 px-3 py-2 me-2">
          {{ emp_prenom_nom }}
        </span>

        <span class="text-gray-400 fs-7">{{ indicatorLabel }}</span>
      </div>
    </div>
  </a>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "card-etat_emp",
  props: {
    cardClasses: String,
    icon: String,
    eem_libelle: String,
    eem_repas_mois: String,
    eem_kms_mois: String,
    eem_usage_voiture_perso: String,
    eem_usage_voiture_pro: String,
    eem_x_conges: String,
    eem_tot_heures_hno: String,
    color: String,
    arrow: String,
    eem_status: String,
    footerText: String,
    indicatorLabel: String,
    emp_prenom_nom: String
  },
setup() {

  const formatMilliers = (val: string | number | null | undefined) => {
    if (val === null || val === undefined || val === '') return '';
    const n = Number(val);
    if (!isFinite(n)) return String(val);

    return Math.trunc(n).toLocaleString('de-DE');
  };

  return {
    formatMilliers,
  };
},
});

</script>
